(function () {
  var grid = document.getElementById('wishlist-grid');
  var emptyState = document.getElementById('wishlist-empty');
  if (!grid || !emptyState) return;

  var moneyFormat = grid.getAttribute('data-money-format') || '${{amount}}';

  function formatMoney(cents) {
    var value = (cents / 100).toFixed(2);
    var parts = value.split('.');
    var formatted = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',') + '.' + parts[1];
    if (moneyFormat.indexOf('{{amount}}') > -1) {
      return moneyFormat.replace('{{amount}}', formatted);
    }
    if (moneyFormat.indexOf('{{ amount }}') > -1) {
      return moneyFormat.replace('{{ amount }}', formatted);
    }
    return moneyFormat.replace(/\{\{[^}]*\}\}/, formatted);
  }

  function removeIconSvg() {
    return (
      '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" ' +
      'stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">' +
      '<path d="M18 6 6 18"/><path d="M6 6l12 12"/></svg>'
    );
  }

  function buildCard(product) {
    var variant = product.variants && product.variants[0] ? product.variants[0] : null;
    var image = product.featured_image || (product.images && product.images[0]) || '';
    var price = variant ? variant.price : product.price;
    var comparePrice = variant ? variant.compare_at_price : product.compare_at_price;
    var onSale = comparePrice && comparePrice > price;
    var available = product.available;

    var card = document.createElement('div');
    card.className = 'wishlist-card';
    card.setAttribute('data-handle', product.handle);

    var priceHtml = onSale
      ? '<span class="wishlist-card__compare">' +
        formatMoney(comparePrice) +
        '</span><span class="wishlist-card__price--sale">' +
        formatMoney(price) +
        '</span>'
      : formatMoney(price);

    card.innerHTML =
      '<button type="button" class="wishlist-card__remove" data-remove-handle="' +
      product.handle +
      '" aria-label="Remove from wishlist">' +
      removeIconSvg() +
      '</button>' +
      '<a href="/products/' +
      product.handle +
      '" class="wishlist-card__link">' +
      '<div class="wishlist-card__image-wrap">' +
      (image ? '<img src="' + image + '" alt="' + (product.title || '') + '" loading="lazy">' : '') +
      '</div>' +
      '<p class="wishlist-card__title">' +
      (product.title || '') +
      '</p>' +
      '<p class="wishlist-card__price">' +
      priceHtml +
      '</p>' +
      (available ? '' : '<p class="wishlist-card__sold-out">Sold out</p>') +
      '</a>';

    return card;
  }

  function render() {
    var handles = window.CairoWishlist ? window.CairoWishlist.get() : [];

    if (!handles.length) {
      grid.hidden = true;
      grid.innerHTML = '';
      emptyState.hidden = false;
      return;
    }

    Promise.all(
      handles.map(function (handle) {
        return fetch('/products/' + handle + '.js')
          .then(function (res) {
            if (!res.ok) throw new Error('not found');
            return res.json();
          })
          .catch(function () {
            // Product was deleted/unpublished since it was wishlisted — drop it silently.
            if (window.CairoWishlist) window.CairoWishlist.remove(handle);
            return null;
          });
      })
    ).then(function (products) {
      var valid = products.filter(Boolean);

      if (!valid.length) {
        grid.hidden = true;
        grid.innerHTML = '';
        emptyState.hidden = false;
        return;
      }

      grid.innerHTML = '';
      valid.forEach(function (product) {
        grid.appendChild(buildCard(product));
      });
      grid.hidden = false;
      emptyState.hidden = true;
    });
  }

  grid.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-remove-handle]');
    if (!btn) return;
    var handle = btn.getAttribute('data-remove-handle');
    if (window.CairoWishlist) {
      window.CairoWishlist.remove(handle);
    }
    render();
  });

  document.addEventListener('wishlist:updated', render);
  document.addEventListener('DOMContentLoaded', render);

  if (document.readyState !== 'loading') render();
})();
